import React from 'react';
import { Card } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import AuthLogin from './AuthLogin';

const Login = () => {
  return (
    <React.Fragment>
      
      <div className="">
        <div className="">          
              <AuthLogin />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Login;
